export default __webpack_public_path__ + "static/media/Landing_Logo_Movistar.85e80ce5.png";